import { render } from "./ExamDetailView.vue?vue&type=template&id=0078869e&scoped=true"
import script from "./ExamDetailView.vue?vue&type=script&lang=js"
export * from "./ExamDetailView.vue?vue&type=script&lang=js"

import "./ExamDetailView.vue?vue&type=style&index=0&id=0078869e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0078869e"]])

export default __exports__